export function safe(generator) {
  return function* f(...args) {
    try {
      yield generator(...args);
    } catch (ex) {
      console.error(ex);
      alert(`错误：${ex.message}`);
    }
  };
}

export function translateFaceDiagnosisResult(result) {
  if (!result || !result.examination || !result.examination.face_result) {
    return {};
  }
  const faceResult = result.examination.face_result;
  const {
    face_L, face_a, face_b,
    gloss_indicator,
  } = faceResult;
  let {
    lip_L, lip_a, lip_b
  } = faceResult;
  const answer = {};
  try {
    answer.faceColor = `${'面白,面黑,面红,面黄,面青,正常'.split(',')[faceResult.faceColor]}`;
    answer.faceGloss = `${'有光泽,少光泽,无光泽'.split(',')[faceResult.faceGloss]}`;
    if (faceResult.lipDetectRes) {
      answer.lipColor = `${'唇淡白,唇淡红,唇红,唇暗红,唇紫'.split(',')[faceResult.lipColor]}`;
    } else {
      answer.lipColor = '未检测到唇';
      // eslint-disable-next-line camelcase,no-multi-assign
      lip_L = lip_a = lip_b = '-';
    }
  } catch (e) {
    answer.error = `无法解析，原始结果：${JSON.stringify(result)}`;
  }

  return {
    ...answer,
    face_L, face_a, face_b,
    gloss_indicator, lip_a, lip_b, lip_L,
  };
}

export function translateTongueDiagnosisResult(result) {
  if (!result || !result.examination || !result.examination.tongue_result) {
    return {};
  }
  const tongueResult = result.examination.tongue_result;
  const {
    crack,
    coat_L, coat_a, coat_b,
    nature_L, nature_a, nature_b,
  } = tongueResult;
  const answer = {};
  try {
    answer.tongueCrack = `${'无裂纹,有裂纹'.split(',')[tongueResult.tongueCrack]} `;
    answer.tongueFatThin = `${'正常,胖舌'.split(',')[tongueResult.tongueFatThin]} `;
    answer.tongueCoatThickness = `${'薄苔,厚苔'.split(',')[tongueResult.tongueCoatThickness]} `;
    answer.tongueCoatColor = `${'苔白,苔黄'.split(',')[tongueResult.tongueCoatColor]} `;
    answer.tongueNatureColor = `${'舌暗红,舌淡白,舌淡红,舌红,舌深红（舌紫）'.split(',')[tongueResult.tongueNatureColor]}`;
  } catch (e) {
    answer.error = `无法解析，原始结果：${JSON.stringify(result)}`;
  }
  const shapeElements = [];
  if (tongueResult.tongueFatThin !== 0) {
    shapeElements.push(answer.tongueFatThin);
  }
  if (tongueResult.tongueCrack !== 0) {
    shapeElements.push(answer.tongueCrack);
  }

  return {
    ...answer,
    crack,
    coat_L, coat_a, coat_b,
    nature_L, nature_a, nature_b,
    shape: shapeElements.length > 0 ? shapeElements.join('、') : '正常'
  };
}



// WEBPACK FOOTER //
// ./src/sagas/util.js